























































































import { Component, Vue } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails'
import PageNames from '@/router/PageNames';
import LocationDto from '@/models/Locations/LocationDto'
import GiganautVue from '@/components/Shared/GiganautVue';
import AddressUtils from '@/lib/addressUtils';
import CompanyLocationCreate from '@/components/Companies/CompanyLocationCreate.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'CompanyLocationList',
  components: { CompanyLocationCreate }
})
export default class extends GiganautVue {

    infoWindowPos: any = null;
    infoWinOpen = false;
    currentMidx: any = null;

    infoOptions: any = {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
            width: 0,
            height: -35
        }
    };

    async created() {
        await  CompanyDetailsModule.getLocations();
    }

    get loading() {
        return CompanyDetailsModule.loadingLocations;
    }

    get locations() {
        return CompanyDetailsModule.locations;
    }

    async navigateToLocation(item: LocationDto) {
        const locationId = item.id;
        this.$router.push({ name: PageNames.AgencyLocationDetails, params: { locationid: locationId } });
    }

      async toggleInfoWindow(location: any, idx: any) {
        this.infoWindowPos = {lng:location.longitude,lat:location.latitude}
        this.infoOptions.content = "<p class='body-2'>" + location.brandName + "</p><p>" + AddressUtils.fullAddressLine(location) + "</p><p><a href='" + window.location + "/" + location.id + "' target='_blank'>Open in new tab</a>";

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

        }
  }

    private search = '';
  
    private headers = [
    { text: 'Brand Name', value: 'brandName' },
    { text: 'Address' },
    { text: AppModule.currentAgencyContext.labels.location + ' Type'},
    ]
}
